import { Button } from "@chakra-ui/button";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogContent,
} from "@chakra-ui/modal";
import React from "react";
import { Quote } from "../lib/models/quote.model";

export interface DeleteQuoteDialogProps {
  isOpen: boolean;
  isQuoteDeleting: boolean;
  quoteToDelete: Quote | null;
  onCloseHandler?: () => void;
  onConfirmHandler?: () => void;
}

function DeleteQuoteDialog(props: DeleteQuoteDialogProps) {
  const { onCloseHandler, onConfirmHandler, isQuoteDeleting } = props;
  const [isOpen, setIsOpen] = React.useState(props.isOpen ?? false);
  const cancelRef = React.useRef(null);

  React.useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  const handleClose = () => {
    setIsOpen(!isOpen);
    onCloseHandler && onCloseHandler();
  };

  const handleConfirm = () => {
    setIsOpen(!isOpen);
    onConfirmHandler && onConfirmHandler();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={handleClose}
      leastDestructiveRef={cancelRef}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete Quote
          </AlertDialogHeader>

          <AlertDialogBody>
            Are you sure you want to delete? This action can not be reversed.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={handleClose}
              isLoading={isQuoteDeleting}
              loadingText="Deleting.."
            >
              Cancel
            </Button>
            <Button colorScheme="red" onClick={handleConfirm} ml={3}>
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default DeleteQuoteDialog;
